import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
import { L10nTranslationService } from 'angular-l10n';
@Component({
  selector: 'app-products-phishing',
  templateUrl: './products-phishing.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./products-phishing.component.scss']
})
export class ProductsPhishingComponent implements OnInit {
  banner = {
    imageText: "Managed Awareness",
    imageUrl: "/assets/images/Frame48096932.jpg",
    buttonText: "Learn more",
    routerButton: '/services/Awareness'
  }
  currentLanguage = this.commonService.currentLanguage;
  subImgUrl = '../../../../assets/images/fingercriclee.svg'
  subTitle = 'Our certified experts can design and run your awareness program and provide you with performance reports';
  items = [
    'Constant updating of content by our cyber security team based on continuous research and latest surveys from various sources',
    'Content available in both Arabic and English to suit the different workers in your facility',
    'The content is in the flexible SCORM format, and you can upload the training content developed by you in the same format',
    'The library features content suitable for different levels, so that you can select the appropriate training material for each employee according to his level',
  ];
  tileList = 'we update content based on continuous R&D of latest cyber threats';
  descriptionList = 'Choose the training material from the database that we provide to you on the platform and update it continuously Which we took into account to fit our local culture and provide awareness of realistic attacks in our surroundings';
  imgListPath = '../../../../assets/images/Group39233.png';
  routerListButton = '//contact-us';
  buttonListText = 'Request a demo';

  automationItems = [
    'An advanced scheduling system to set campaign execution dates and parameters',
    'Continuous automatic synchronization of adding and deleting employees on the platform',
    'Automatic monitoring of performance indicators for each employee and launching appropriate campaigns',
    'Flexibility to combine automation and manual launch of various campaigns to suit your desired management style'
  ];
  automationTileList = 'High Automation Of Your Awareness Operations';
  automationDescriptionList = 'Automate many processes that usually consume your time and effort';
  automationRouterListButton = '//contact-us';
  automationButtonListText = 'Request a demo';
  automationImgListPath = '../../../../assets/images/Cardawerness.png'

  employeeItems = [
    'Cyber knowledge values',
    'Determine development points',
    'Launch training campaigns'
  ];
  employeeItemsTileList = 'Measure Employees Cyber Knowledge And Identify Their Weaknesses';
  employeeDescriptionList = 'Auto-enroll users onto personalized training courses';
  employeeRouterListButton = '//contact-us';
  employeeButtonListText = 'Request a demo';
  employeeImgListPath = '../../../../assets/images/undraw_collaborating_re_l2.png'

  header: string = 'Security Awarness';
  description: string =
    'Automated tailored training with updated content';
  joinChat: boolean = false;
  imagePath: string;
  hasBtn: boolean = true;
  routerHeroButton = '/contact-us';
  buttonText = 'Request a demo';
  isProductsPage: boolean = true;
  isProductLogo: boolean = true;
  logoPath ='../assets/svg/awareness 10®.svg'
  sectionInputTwoCards: any = [
    {
      description:
        'Pre-built libraries of awareness content including courses, posters, and phishing templates. ',
      imagePath: '../../../../assets/images/image4.png',
    },
    {
      description:
        'New content is added continuously to keep your program up to date with latest threats trends. ',
      imagePath: '../../../../assets/images/image3.png',
    },
    {
      description: 'Launch campaigns with professional content in seconds. ',
      imagePath: '../../../../assets/images/image2.png',
    },
    {
      description:
        'New content is added continuously to keep your program up to date with latest threats trends. ',
      imagePath: '../../../../assets/images/image1.png',
    },
  ];
  sectionCards: { imagePath: string; description: string; title: string }[] = [
    {
      title: 'Clone Framework',
      description:
        'Clone a framework from a multitude of options already available on our database  ',
      imagePath: '../../../../assets/images/clone.svg',
    },
    {
      title: 'Map Evidence',
      description:
        'Define your compliance level based on the date from the system ',
      imagePath: '../../../../assets/images/map.svg',
    },
    {
      title: 'Assess Compliance',
      description:
        'Define your compliance level based on the date from the system',
      imagePath: '../../../../assets/images/assess.svg',
    },
  ];

  sectionNine: { imagePath: string; title: string }[] = [
    {
      title: 'Courses',
      imagePath: '../../../../assets/images/course.svg',
    },
    {
      title: 'Games',
      imagePath: '../../../../assets/images/games.svg',
    },
    {
      title: 'Posters',
      imagePath: '../../../../assets/images/posters.svg',
    },
    {
      title: 'Stories',
      imagePath: '../../../../assets/images/stories.svg',
    },
  ];



  sectionMicroLearning: { imagePath: string; title: string }[] = [
    {
      title: 'Courses',
      imagePath: '../../../../assets/images/courses.png',
    },
    {
      title: 'Games',
      imagePath: '../../../../assets/images/game.png',
    },
    {
      title: 'Posters',
      imagePath: '../../../../assets/images/poster.png',
    },
    {
      title: 'Stories',
      imagePath: '../../../../assets/images/stories.png',
    },
  ];

  accordionItems = [
    { id: 0, title: 'Assess', body: ['Send realistic phishing emails to understand how far your organization is prepared to respond to cyberattacks and train employees to deal with real attacks when they happen', 'Send cultural and knowledge assessments to understand the organizational context and run adequate training campaigns', '  Establish a baseline using first assessment results and measure awareness level progress with future assessments'] },
    { id: 1, title: 'Train', body: ['Provide fun and engaging training content with a micro-learning approach', 'Keep your training courses short and fun to ensure maximum benefit to employees', 'Avoid tedious and lengthy training with our micro-learning training courses','Secure your employees’ best responses with the most positive impact'] },
    { id: 2, title: 'Reinforce', body: ['Publish reinforcement content to consolidate the knowledge gained by employees' , 'Schedule campaigns to run periodically without manual intervention' , 'Automat Email posters sharing with employees based on predefined schedule'] },
    { id: 3, title: 'Measure', body: ['Advance reports across all activities you perform with drill-down details', 'Compare departments’ performances', 'Get a complete employee profile with past and planned activities' , 'Get risky users classified automatically and added to a particular campaign for extra training focus' , 'Calculate the risk score for every user and the organization overall'] },
  ]


  imageText = this.L10nTranslationService.translate("Launch Phishing Simulation");
  routerLink = "/services";
  imageTextPath = "../../../../assets/images/undraw_mobile_search.png";
  buttonImgText = this.L10nTranslationService.translate("Learn more");
  routerButton = "/products-phishing-simulation";
  imageUrl = '../../../../assets/images/Rectangle-47.png';
  subImgUrl2 = '../../../../assets/svg/PhishingSimulation.svg';
  subTitle2 = 'Assess employees readiness with realistic phishing'
  constructor(public commonService: CommonService, private L10nTranslationService: L10nTranslationService) { }

  ngOnInit(): void {
    if (this.currentLanguage === 'ar') {
      this.automationImgListPath = '../../../../assets/images/CardAwerness-ar.png'
    }

    if (this.currentLanguage == 'en') {
      this.imagePath = '../../../../assets/images/Hero-Section Awareness En.png';
    } else {
      this.imagePath = '../../../../assets/images/Hero-Section Awareness AR.png';
    }
  }

}
